import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { allowedDataDefinitionListProps } from '../utils/allowedPropTypes';
import OutputProcessor from './_OutputProcessor';

const DataDefinitionListContent = (
  {
    listData, // JSON or array
    preprocessDefinitionTerms,
    preprocessNestingTerms,
    preprocessDefinitionDescriptions,
    classNames = [],
    cellVerticalAlign = 'top',
    hasWideDescriptions,
    key
  }
) => {
  const entries = Object.entries(listData);

  classNames.push('data-lists', 'component-data-dl', `cell-content-align-${cellVerticalAlign}`);

  if (hasWideDescriptions) {
    classNames.push('has-wide-descriptions');
  }

  const attributes = { className: classNames.join(' ') };

  if (key) {
    attributes.key = key;
  }

  return (
    <dl {...attributes}>
      {entries.map(entry => {
        const {
          0: definitionTerm,
          1: definitionDescription
        } = entry;

        const descriptionProps = {
          definitionTerm,
          definitionDescription,
          preprocessDefinitionTerms,
          preprocessNestingTerms,
          preprocessDefinitionDescriptions,
          key: uuidv4()
        };

        return <OutputProcessor {...descriptionProps} />;
      })}
    </dl>
  );
};

DataDefinitionListContent.propTypes = allowedDataDefinitionListProps;

export default DataDefinitionListContent;